import orderLayout from '@/pages/order/layout'
import orderBoardIndexPage from '@/pages/order/board/index'
const routes = {
	path: '/orders',
	component: orderLayout,
	children: [
		{
			path: 'board',
			component: orderBoardIndexPage,
			meta: {title: 'Доска почёта', breadcrumb: 'Доска почёта'}
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/order.js